<template>
  <a-modal
    :title="title"
    :width="640"
    :visible="visible"
    :confirmLoading="confirmLoading"
    :maskClosable="false"
    @cancel="handleCancel"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item
          v-show="!addable"
          label="id"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            v-decorator="['id']"
            :readonly="editable || showable"
          />
        </a-form-item>
        <a-form-item
          label="上级名称"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          v-show="permsType === '1' || permsType === '2'"
        >
          <a-input :readonly="true" v-decorator="['parentName']" ></a-input>
        </a-form-item>
        <a-form-item
          label="上级id"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          :hidden="true"
        >
          <a-input :readonly="true" v-decorator="['parentId']"></a-input>
        </a-form-item>
        <a-form-item
          label="名称"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            :readonly="showable"
            v-decorator="['title', {rules: [{required: true, message: '请输入名称'}]}]" />
        </a-form-item>
        <a-form-item
          label="权限代码"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            :readonly="showable"
            v-decorator="['perms', {rules: [{required: true, message: '请输入权限代码'}]}]" />
        </a-form-item>
      </a-form>
    </a-spin>

    <template slot="footer">
      <div v-show="!showable">
        <a-button key="cancel" @click="handleCancel">取消</a-button>
        <a-button key="forward" :loading="confirmLoading" type="primary" @click="handleOk">保存</a-button>
      </div>
    </template>
  </a-modal>
</template>

<script>
import pick from 'lodash.pick'
import { addObj, putObj, getObj } from '@api/sys/menu'
import { FormMixin } from '@/mixins/FormMixin'

export default {
  name: 'PermissionAddOrUpdate',
  mixins: [FormMixin],
  data () {
    return {
      visible: false,
      confirmLoading: false,
      form: this.$form.createForm(this),
      permsType: '0',
      treeData: []
    }
  },
  methods: {
    edit (tmpRecord, type, permsType) {
      this.permsType = permsType
      this.visible = true
      const { form: { setFieldsValue, resetFields } } = this
      this.$nextTick(() => {
        setFieldsValue({
          parentName: tmpRecord.title,
          parentId: tmpRecord.id || ''
        })
      })
      if (['edit', 'show'].includes(type)) {
        this.confirmLoading = true
        getObj(tmpRecord.id).then(res => {
          const record = res.data
          record.parentId = String(record.parentId)
          this.confirmLoading = false
          this.$nextTick(() => {
            setFieldsValue(pick(record, ['id', 'title', 'type', 'perms', 'parentId']))
          })
        })
      } else {
        resetFields()
      }
    },
    handleOk () {
      const validateFieldsKey = ['id', 'title', 'perms', 'parentId']
      this.form.validateFields(validateFieldsKey, async (err, values) => {
        if (!err) {
          this.confirmLoading = true
          try {
            values.type = this.permsType
            if (this.type === 'add') {
              await addObj(values)
            } else if (this.type === 'edit') {
              await putObj(values)
            }
            setTimeout(() => {
              this.confirmLoading = false
              this.$emit('ok')
              this.visible = false
            }, 1500)
          } catch (err) {
            this.$message.error(err.msg)
            this.confirmLoading = false
          }
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
